<template>
  <div>
    <div v-if="loading" style="padding:20px">
      <div class="ui active centered inline large loader"></div>
    </div>
    <div v-else class="ui grid" style="padding:20px">
      <div class="row">
        <div class="six wide column">
          <div class="ui header">Configuration</div>
        </div>
      </div>
      <div class="row">
        <div class="sixteen wide column">
          <div class="ui form">
            <div class="field">
              <div class="ui checkbox labelCursorFix">
                <input type="checkbox" data-lpignore="true" v-model="skipPackageDimensionChangeIfNoFeeChange" id="checkbox334457">
                <label for="checkbox334457">Dimension changes: Only alert if FBA fee changed as well</label>
              </div>
            </div>
            <div class="field">
              <div class="ui checkbox labelCursorFix">
                <input type="checkbox" data-lpignore="true" v-model="sendAlertForEstimateChanges" id="checkbox334457b">
                <label for="checkbox334457b">Send alerts for FBA fee estimate changes <small><a target="_blank" href="https://www.sentrykit.com/knb/fbafeealerts.html">[more info...]</a></small></label>
              </div>
            </div>
            <div class="field">
              <div class="ui checkbox labelCursorFix">
                <input type="checkbox" data-lpignore="true" v-model="sendAlertForOrderDataChanges" id="checkbox334457c">
                <label for="checkbox334457c">Send alerts for FBA fee changes in order data <small><a target="_blank" href="https://www.sentrykit.com/knb/fbafeealerts.html">[more info...]</a></small></label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="six wide column">
          <button v-bind:class="dirty ? 'ui primary button' : 'ui disabled primary button'" v-on:click="save()">Save</button>
          <button class="ui basic button" @click="close()">Close </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: true,
      skipPackageDimensionChangeIfNoFeeChange: false,
      skipPackageDimensionChangeIfNoFeeChangeOrig: false,
      sendAlertForEstimateChanges: true,
      sendAlertForEstimateChangesOrig: true,
      sendAlertForOrderDataChanges: true,
      sendAlertForOrderDataChangesOrig: true,
      dirty: false,
    }
  },
  methods: {
    load: function () {
      this.$http.get('/api/sentinel/watchdogtype/settings/fbaFeeChange').then((response) => {
        this.loading = false
        this.skipPackageDimensionChangeIfNoFeeChange = response.body.skipPackageDimensionChangeIfNoFeeChange
        this.skipPackageDimensionChangeIfNoFeeChangeOrig = response.body.skipPackageDimensionChangeIfNoFeeChange
        this.sendAlertForEstimateChanges = response.body.sendAlertForEstimateChanges
        this.sendAlertForEstimateChangesOrig = response.body.sendAlertForEstimateChanges
        this.sendAlertForOrderDataChanges = response.body.sendAlertForOrderDataChanges
        this.sendAlertForOrderDataChangesOrig = response.body.sendAlertForOrderDataChanges
      }, (response) => {
        this.loading = false
      })
    },
    close: function () {
      this.$parent.showConfiguration = false
    },
    save: function () {
      this.$http.put('/api/sentinel/watchdogtype/settings/fbaFeeChange', {
        skipPackageDimensionChangeIfNoFeeChange: this.skipPackageDimensionChangeIfNoFeeChange,
        sendAlertForEstimateChanges: this.sendAlertForEstimateChanges,
        sendAlertForOrderDataChanges: this.sendAlertForOrderDataChanges,
      }).then((response) => {
        this.skipPackageDimensionChangeIfNoFeeChangeOrig = this.skipPackageDimensionChangeIfNoFeeChange
        this.sendAlertForEstimateChangesOrig = this.sendAlertForEstimateChanges
        this.sendAlertForOrderDataChangesOrig = this.sendAlertForOrderDataChanges
        this.updateDirty()
      }, (response) => {
        this.loading = false
      })
    },
    updateDirty: function () {
      this.dirty = this.skipPackageDimensionChangeIfNoFeeChange !== this.skipPackageDimensionChangeIfNoFeeChangeOrig || this.sendAlertForEstimateChanges !== this.sendAlertForEstimateChangesOrig || this.sendAlertForOrderDataChanges !== this.sendAlertForOrderDataChangesOrig
    }
  },
  created: function () {
    this.load()
  },
  watch: {
    skipPackageDimensionChangeIfNoFeeChange: function () {
      this.updateDirty()
    },
    sendAlertForEstimateChanges: function () {
      this.updateDirty()
    },
    sendAlertForOrderDataChanges: function () {
      this.updateDirty()
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// FBAFeeChangeConfig.vue?5fd15e87